<template>

    <section class="inbox">
            <div class="panel">
            <div class="panel-heading"><h2>Inbox<i class="clippie fa fa-info-circle" v-tooltip="'Inbox is for private messaging members of Portal'"></i></h2></h2></div>
        <div class="tab-body">
            <p>We’ve phased out Inbox for our new <a href="#" @click.prevent="openChat()">Chat App!</a><br>
            October intake, we’ll leave this up to save your messages if you want.<br>
            We’ll remove Inbox entirely in a few weeks, thanks for your feedback!</p>
            <ul class="tabs clearfix">
                <li @click="tab='compose'"><span :class="{'active': tab==='compose'}">Compose</span></li>
                <li @click="tab='inbox'; selectedMessage = null; getMessages('to', false)"><span :class="{'active': tab==='inbox'}">Inbox</span></li>
                <li @click="tab='sent'; selectedMessage = null; getMessages('from', false)"><span :class="{'active': tab==='sent'}">Sent</span></li>
                <li @click="tab='trash'; selectedMessage = null; getMessages('both', true)"><span :class="{'active': tab==='trash'}">Trash</span></li>
                <li @click="tab='support'"><span :class="{'active': tab==='support'}">Support</span></li>

            </ul>
        </div>
        <div v-if="tab==='compose'" class="panel">
            <div class="panel-body">

                <form class="new-message" @submit.prevent="send()">
                    <div class="form-group">
                    <div class="input-tag-wrapper form-control">
                        <input type="text" v-model="searchTerm" placeholder="To:">  
                        <span v-for="recipient in recipients" @click="toggleRecipient(recipient)" class="tag">
                            <img :src="recipient.roles | roleIcon" class="role-icon"> {{recipient.firstName}} {{recipient.lastName}}
                        </span>      
                    </div>              
                        <ul class="users" v-if="users&&searchTerm">
                            <li @click="toggleRecipient(user)" v-for="user in users" v-show="filterUsers(user.firstName + ' ' + user.lastName)"><img :src="user.roles | roleIcon" class="role-icon"> {{user.firstName}} {{user.lastName}}</li>
                            <li @click="addGroupMembers(group)" v-for="group in groups">Send to Group {{group}}</li>
                        </ul>
                    </div>
                    <div class="form-group">
                        <input type="text" v-model="message.title" class="form-control" placeholder="Subject">
                    </div>
                    <div class="form-group">
                        <vue-html5-editor @change="updateMessageContent" :content="messageContent" :height="200"></vue-html5-editor>

                    </div>
                    <div class="form-group">
                        <button type="submit" class="btn btn-success">Send</button>
                    </div>
                </form>
            </div>
        </div>


        <div v-if="tab==='inbox'" class="panel">
            <!-- {{count}} messages -->
            <div class="panel-body nopad">
            <ul v-if="messages" class="messages">
                <li v-for="(message, index) in messages" class="clearfix">
                    <div v-if="!message.replies || message.replies.length===0" class="table-row message"  
                    @click="selectMessage(message, index); showMessage=message.id">
                        <div class="col-xs-12 col-md-2 avatar-wrapper">
                        <span class="badge new-message" v-if="message.readBy.indexOf(localStorage.user_id) === -1">New</span>
                        <img class="avatar-image" :src="message.sender.avatar">
                        </div>

                        <div class="col-xs-12 col-md-4">
                        <span class="bold">From: <img :src="message.sender.roles | roleIcon" class="role-icon"> {{message.sender.firstName}} {{message.sender.lastName}}</span><br>
                        {{message.createdAt | shortDate}}
                        </div>

                        <div class="col-xs-12 col-md-9">
                            <span class="bold">{{message.title}}</span>
                            <p class="excerpt" >{{message.body | excerpt}}</p>
                        </div>                        
                    </div>
                    <div v-else class="table-row message" @click="selectMessage(message, index); showMessage=message.id">
                        <div class="col-xs-12 col-md-2 avatar-wrapper">
                        <span class="badge new-message" v-if="message.readBy.indexOf(localStorage.user_id) === -1">New</span>
                        <img class="avatar-image" :src="message.replies[0].sender.avatar">
                        </div>

                        <div class="col-xs-12 col-md-4">
                        <span class="bold">From: <img :src="message.replies[0].sender.roles | roleIcon" class="role-icon"> {{message.replies[0].sender.firstName}} {{message.replies[0].sender.lastName}}</span><br>
                        {{message.replies[0].createdAt | shortDate}}
                        </div>

                        <div class="col-xs-12 col-md-9">
                            <span class="bold">Re: {{message.title}}</span>
                            <p class="excerpt" >{{message.replies[0].body | excerpt}}</p>
                        </div> 
                    </div>
                  
                    <div class="col-xs-12 body" v-if="selectedMessage && showMessage===message.id">
                        <h3>{{message.title}}</h3>
                        <div class="message-body" v-html="$options.filters.linkify(message.body)"></div>
                            <ul class="replies" v-if="replies">
                                <li v-for="reply in replies" class="clearfix">
                                    <div class="col-xs-12 col-md-2 text-center avatar-message">
                                        <img class="avatar-image" :src="reply.sender.avatar">
                                         <img :src="reply.sender.roles | roleIcon" class="role-icon">

                                        {{reply.sender.firstName}} {{reply.sender.lastName}}<br>                
                                        {{reply.createdAt | shortDate}}
                                    </div>
                                    <div class="col-xs-12 col-md-10">
                                        <div v-html="$options.filters.linkify(reply.body)"></div>
                                    </div>
                                </li>
                            </ul>
                        <form class="col-xs-12" @submit.prevent="reply(message.to)">
                            <div class="form-group">
                                 <vue-html5-editor @change="updateReplyContent" :content="replyContent" :height="200"></vue-html5-editor>
                            </div>
                            <button type="submit" class="btn btn-success">Reply</button>
                            <button @click.prevent="deleteMessage(message, index)" class="btn btn-danger delete">Delete</button>

                        </form>
                    </div>

                </li>
            </ul>
            <div class="message-pagination" v-show="messages && messages.length > 10000">
                <div class="col-xs-6"><button @click.prevent="getPrevious('to', false)" class="btn btn-success">Previous</button></div>
                <div class="col-xs-6 text-right"><button @click.prevent="getNext('to', false)" class="btn btn-success">Next</button></div>
            </div>
            </div>

        </div>

        <div v-if="tab==='sent'" class="panel">

            <div class="panel-body nopad">
            <ul v-if="messages" class="messages">
                <li v-for="(message, index) in messages" class="clearfix">
                    <div v-if="message.to" class="table-row message" @click="selectMessage(message); showMessage=message.id">
                        <div class="col-xs-12 col-md-2 avatar-wrapper">
                        <img class="avatar-image" :src="message.recipient.avatar">
                        </div>

                        <div class="col-xs-12 col-md-4">
                            <span class="bold">To: <img :src="message.recipient.roles | roleIcon" class="role-icon"> {{message.recipient.firstName}} {{message.recipient.lastName}}</span><br>
                        
                        {{message.createdAt | dayOnly}}
                        </div>

                        <div class="col-xs-12 col-md-9">
                            <span class="bold">{{message.title}}</span>
                            <p class="excerpt" >{{message.body | excerpt}}</p>
                        </div>
                    </div>
                    <div class="col-xs-12 body" v-if="selectedMessage && showMessage===message.id">
                        <h3>{{message.title}}</h3>
                        <div class="message-body" v-html="$options.filters.linkify(message.body)"></div>
                            <ul class="replies" v-if="replies">
                                <li v-for="reply in replies" class="clearfix">
                                    <div v-if="reply.sender" class="col-xs-12 col-md-2 text-center">
                                        <img class="avatar-image" :src="reply.sender.avatar">
                                        {{reply.sender.firstName}} {{reply.sender.lastName}}<br>                
                                        {{reply.createdAt | shortDate}}
                                    </div>
                                    <div class="col-xs-12 col-md-10">
                                        <div v-html="$options.filters.linkify(reply.body)"></div>
                                    </div>
                                </li>
                            </ul>
                        <form class="col-xs-12" @submit.prevent="reply()">
                            <div class="form-group">
                                 <vue-html5-editor @change="updateReplyContent" :content="replyContent" :height="200"></vue-html5-editor>
                            </div>
                            <button type="submit" class="btn btn-success">Reply</button>

                        </form>
                    
                    </div>

                </li>
            </ul>
            <div class="message-pagination">
                <div class="col-xs-6"><button @click.prevent="getPrevious('from', false)" class="btn btn-success">Previous</button></div>
                <div class="col-xs-6 text-right"><button @click.prevent="getNext('from', false)" class="btn btn-success">Next</button></div>
            </div>
            </div>
        </div>

        <div v-if="tab==='trash'" class="panel">
            <div class="panel-body nopad">
            <ul v-if="messages" class="messages">
                <li v-for="(message, index) in messages" class="clearfix" @click="selectMessage(message); showMessage=message.id">
                    <div class="table-row message">
                        <div class="col-xs-12 col-md-2 avatar-wrapper">
                        <img class="avatar-image" :src="message.sender.avatar">
                        </div>

                        <div class="col-xs-12 col-md-3">
                        <span class="bold">From: {{message.sender.firstName}} {{message.sender.lastName}}</span><br>
                        {{message.createdAt | dayOnly}}
                        </div>

                        <div class="col-xs-12 col-md-6">
                            <span class="bold">{{message.title}}</span>
                            <p class="excerpt" >{{message.body | excerpt}}</p>
                        </div>

                        <div class="col-xs-12 col-md-3">
                            <span class="bold">Deleted:</span>
                            <p>{{message.deletedAt | dayOnly}}</p>
                        </div>
                    </div>
                  
                    <div class="col-xs-12 body" v-if="showMessage===message.id">
                        <h3>{{message.title}}</h3>
                        <button class="btn btn-primary" @click.prevent="undeleteMessage(message.id)">Restore</button>
                        <div class="message-body" v-html="$options.filters.linkify(message.body)"></div>
                            <ul class="replies" v-if="replies">
                                <li v-for="reply in message.replies" class="clearfix">
                                    <div class="col-xs-12 col-md-2 text-center avatar-wrapper">
                                        <img class="avatar-image" :src="reply.sender.avatar">
                                        <img :src="reply.sender.roles | roleIcon" class="role-icon"> {{reply.sender.firstName}} {{reply.sender.lastName}}<br>                
                                        {{reply.createdAt | shortDate}}
                                    </div>
                                    <div class="col-xs-12 col-md-10">
                                        <div v-html="$options.filters.linkify(reply.body)"></div>
                                    </div>
                                </li>
                            </ul>
                    
                    </div>

                </li>
            </ul>
            <div class="message-pagination">
                <div class="col-xs-6"><button @click.prevent="getPrevious('both', true)" class="btn btn-success">Previous</button></div>
                <div class="col-xs-6 text-right"><button @click.prevent="getNext('both', true)" class="btn btn-success">Next</button></div>
            </div>
            </div>
        </div>

        <div v-if="tab==='support'">
            <support></support>
        </div>
    </div>
    </section>
</template>


<script>

import users from '../services/users';
import messages from '../services/messages';

import toastr from 'toastr';
import support from './Support.vue';

export default {

    data() {
        return {
            message: {},
            users: null,
            searchTerm: null,
            recipients: [],
            showMessage: null,
            selectedMessage: null,
            replyBody: null,
            replies: null,
            count: 0,
            page: 0,
            tab: 'compose',

        }
    },
    components: {
        support
    },
    mounted() {
        this.getUsers();
        if (this.$route.query.tab) {
            this.tab = this.$route.query.tab;
            if (this.tab === 'inbox') {
                this.getMessages('to', false);
            }            
        }

    },
    methods: {
        openChat() {
            let chatWindow = window.open(window.chatUrl + '/home?user_id=' + localStorage.rocket_id + '&token=' + localStorage.rocket_token + '&origin=portal', '_blank', 'location=0,height=570,width=960,scrollbars=yes,status=0');

        },
        updateMessageContent(content) {
            this.message.body = content;
        },
        updateReplyContent(content) {
            this.replyBody = content;
        },
        callbackMethod(e) {
            console.log(e);
        },
        filterUsers(name) {
            if (this.searchTerm.trim() === '') return false;
            return name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
        },
        addGroupMembers(group) {
            var self = this;
            group = parseInt(group);

            this.users.forEach(function(user) {
                if (user.group && user.group.indexOf(group) > -1) {
                    var existing = self.recipients.findIndex(function(r) { return r.id === user.id});
                    if (existing === -1) {
                        self.recipients.push(user)
                    }
                }
            })
        },
        toggleRecipient(user) {
            var index = this.recipients.findIndex(function(r) { return r.id === user.id});
            if (index === -1) {
                this.searchTerm = null;
                this.recipients.push(user);
            } else {
                this.recipients.splice(index, 1);
            }
        },
        deleteMessage(message, index) {
            var self = this;
            var data = {
                messageId: message.id,
                to: message.to
            }
            messages.delete(this, data).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Message deleted');
                    var data = {
                        type: 'messages',
                        id: message.id
                    }
                    self.$store.dispatch('remove', data);
                } else {
                    toastr.error('Message not deleted');
                }
            });
        },
        undeleteMessage(message, index) {
            var self = this;
            var data = {
                messageId: message.id,
                to: message.to
            }
            messages.undelete(this, data).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Message restored');
                    self.getMessages();
                } else {
                    toastr.error('Message not restored');
                }
            });
        },
        selectMessage(message, index) {
            var self = this;
            if (self.selectedMessage && message.id === self.selectedMessage.id) {
                self.selectedMessage = null;
                return;
            }
            if (message.readBy.indexOf(localStorage.user_id) === -1) {
                messages.markAsRead(this, message.id).then(function(response) {
                    self.messages[index].readBy.push(parseInt(localStorage.user_id));
                    self.$store.dispatch('decrement', 'unreadMessages');
                });
            }
            self.selectedMessage = message;
            this.getReplies();
        },
        getReplies() {
            var self = this;
            // console.log(JSON.stringify(this.selectedMessage,null,2));return;

            messages.getReplies(this, this.selectedMessage.id).then(function(res) {
                console.log(res);
                console.log('REPLIES');
                console.log(res.data);
                self.replies = res.data;
            });

        },
        getUsers() {
            var self = this;
            users.getAll(this, ['Student','Supervisor','Support'], 'Admin').then(function(response) {
                var users = response.data.filter(function(u) { return u.id != window.localStorage.user_id});
                self.users = response.data;
                    if (self.$route.query.to) {
                        let index = self.users.findIndex(function(u) { return u.id === self.$route.query.to});
                        self.recipients.push(self.users[index])
                    }
            });
        },
        getPrevious(direction, deleted) {
            if (this.page < 1) return;
            this.page--;            
            this.getMessages(direction, deleted);
        },
        getNext(direction, deleted) {
            if (this.page >= Math.floor(this.count / 10000)) return;
            
            this.page++;

            this.getMessages(direction, deleted);
        },
        getMessages(direction, deleted) {
            var self = this;
            self.$store.dispatch('toggle',{type:'loading', boolean: true});
            messages.get(this, this.page, direction, deleted).then(function(response) {
                console.log(response);
                self.count = response.data.count;
                var data = {
                    type: 'messages',
                    data: response.data.rows
                }
                self.$store.dispatch('populate', data);
                self.$store.dispatch('toggle',{type:'loading', boolean: false});
            });
        },
        reply(to) {
            toastr.error('Please use our new Chat App!');
            return false;
            
            var self = this;
            if (!this.replyBody) {
                toastr.error("Please enter a reply body");
                return false;
            }
            var userId = window.localStorage.user_id;
            var data = {
                body: this.replyBody,
                messageId: this.selectedMessage.id,
                from: userId                
            }

            if (to !== userId) {
                data.to = to;
            }


            messages.reply(this, data).then(function(response) {
                if (response.data.success === false) {
                    toastr.error('Error sending message');
                } else {   
                    self.replyBody = null;
                    document.querySelector('.content').innerHTML = ''
                    self.getReplies(self.selectedMessage);
                    // var direction;
                    // if (self.tab === 'inbox') direction = 'to';
                    // else if (self.tab === 'sent') direction = 'from';
                    // self.getMessages(direction, false);
                    toastr.success('Message sent.') 
                }
            });
        },
        send() {
            toastr.error('Please use our new Chat App!');
            return false;

            var self = this;
            if (this.recipients.length < 1) {
                toastr.error("Please select at least one recipient.");
                return false;
            }
            if (!this.message.body) {
                toastr.error("Please enter a message body");
                return false;
            }
            if (!this.message.title) {
                toastr.error("Please enter a message subject");
                return false;
            }
            var recipients = this.recipients.map(function(r) {
                return r.id;
            });

            var data = {
                to: recipients,
                from: window.localStorage.user_id,
                title: this.message.title,
                body: this.message.body
            }
            messages.send(this, data).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Message sent');
                    self.recipients = [];
                    self.message.title = null;
                    self.message.body = null;
                    self.searchTerm = null;
                    $('.content').html('');

                } else {
                    toastr.error('Error sending message');
                }
            });           

        }
    },
    computed: {
        messages() {
            return this.$store.getters.messages;
        },
        groups() {
            return localStorage.group.split(',')
        }
    }

}

</script>

<style lang="scss" scoped>
.panel {
    padding:20px;
}
.panel-body {
    padding:20px!important;
}

.delete {
    float:right;
}
.tabs {
    cursor: pointer;
    width:100%;
    clear:both;
    span {
        display:inline-block;
        background: #1B191B;
        padding:1rem 2rem;
        float:left;
        margin: 0 1rem;
        border:solid 1px #1B191B;
        &.active {
            background:#33ccff;
            color:#fff;
        }
    }
    span:hover {
    background:black!important;
    color:white;
    border: solid 1px #33ccff;
    outline-offset: 0px;
    }
}

.message-body {    
    margin:20px 2rem 50px 2rem;
    background:rgb(34, 34, 34);
    padding:2rem;
    span {
        background:transparent!important;
    }
}

.unread {
    background: #33ccff;
    display:inline-block;
    padding:.5rem 1rem;
    color:#fff;
    border-radius:3px;
    margin-right:1rem;
}
.messages {
    li {
        .table-row {
            cursor: pointer;
            display:flex;
            width: 100%;
            & > div {
                padding:1rem;
                border:1px solid #444; 

            }
        }
        .message .avatar {
            object-fit: cover;
            cursor:pointer;
        }
        .message {height:150px;}
      
    }
    .body {
        background:#1a1a1a;
        padding:1rem;
        flex-grow: 2 2 auto;
        h3 {
            margin-left: 2rem;
            margin-right: 2rem;
            border-bottom: 1px solid #444;
            padding-bottom: 1rem;
        }
    }
    .avatar {
        //margin-bottom:1rem;
        //height: 100%;
         /* width: auto;
          max-width: 150px;
          height: auto;
          max-height: 100px;*/
        //width:auto;        
    }
}

.avatar-wrapper {
    //display: flex;
    //justify-content: center;
    //align-items: center;
    overflow: hidden;
    padding:0!important;      
}

.avatar-message {
    border-right:solid 1px #444;
    .avatar-image {

        margin-bottom: 20px;
    }

}
    
.avatar-image {            
    //flex-shrink: 0;
    min-width: 100%;
    min-height: 100%;
    padding:0!important; 
    object-fit:contain;
}   

.input-tag-wrapper {
    height:auto!important;
    padding:0!important;
    min-height:35px!important;
    input {        
        height:100%;
        background: transparent;
        color:#fff;
        outline:none!important;
    }
    .tag {
        display:inline-block;
        background:#43a4c8;
        color:#fff;
        padding:1rem 2rem;
        margin:0 1rem;
        border-radius: 3px;
        cursor:pointer;
        margin-bottom:1rem;
    }
}
.replies {
    border-top:1px solid #ccc;
    li {
        border:none;
        border-bottom: 1px solid #ccc;
        padding:2rem 0;
        span {
            background:transparent!important;
        }
    }
    margin-bottom:2rem;
}
.users {
    border:1px solid #ccc;
    li {
        padding:1rem;
        cursor: pointer;
        &:hover {
            background: #43a4c8;
            color:#fff;
        }
    }
    & > li:not(:last-child) {
        border-bottom: 1px #ccc dashed;
    }
}
.message-pagination {
    margin-top:2rem;
}
.badge.new-message {
    background: rgba(51,204,255,0.5);
    position:absolute;
    border-radius: 0;
    top:0;
    left:0;
}

.bold {
    font-weight: 600;
    color:#fff;
    padding-top:1rem;
    display:inline-block;
    margin-bottom:1.5rem;
}

.panel-body {
    background:#222222;
}

.tab-body {
    background:#222222;
    padding-top:15px; 
    p {
        padding:1rem 2rem;

    }
}

.panel {
    padding:0px;
}
</style>

<style lang="scss">
.vue-html5-editor > .toolbar > ul > li .icon {
    color:#fff!important;
}
.vue-html5-editor {
    background:transparent!important;
    .dashboard {
        background:#444!important;
    }
    .content, .toolbar > .dashboard button, label {
        color:#fff!important;
    }
}

</style>


// WEBPACK FOOTER //
// Inbox.vue?98493efe